import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Button, If, Format, Text } from 'src/Components'
import { IconBell } from 'src/Components/Icon'
import { STREAM_NOTIFICATIONS } from 'src/constants/messages'

import Dropdown from 'src/Components/Dropdown'

import styles from './Notifications.module.scss'

const Notifications = ({
  handleClick,
  intl,
  notifications,
  open,
  setOpen,
  unseenNotifications
}) => (
  <Dropdown
    open={open}
    setOpen={setOpen}
    buttonProps={{
      iconStart: IconBell,
      'data-count': unseenNotifications,
      className: unseenNotifications && styles.notificationBadge
    }}
    headline={
      <FormattedMessage
        id='Notifications.dropdown.headline'
        defaultMessage='Notifications'
      />
    }
  >
    <If condition={notifications.length}>
      <ul className={styles.notificationsList}>
        {notifications.map(({ isSeen, updatedAt, verb }) => (
          <Button
            minimal
            element='li'
            onClick={() => handleClick(verb)}
            key={verb}
            className={classnames(styles.notificationItem, {
              [styles.unseen]: !isSeen
            })}
          >
            <Text className={styles.description}>
              {intl.formatMessage(STREAM_NOTIFICATIONS[verb])}
            </Text>
            <Text size='s' color='quiet' className={styles.date}>
              <Format.Date fromNow value={updatedAt} />
            </Text>
          </Button>
        ))}
      </ul>
    </If>
    <If condition={!notifications.length}>
      <Text className={styles.empty}>
        <FormattedMessage
          id='Notifications.dropdown.emptyMessage'
          defaultMessage='You have no notifications at this time'
        />
      </Text>
    </If>
  </Dropdown>
)

export default Notifications
